import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { OptionsType } from 'cookies-next/lib/types'
import { PKCE_VERIFIER_COOKIE } from '@/constants/cookies'
import { Durations } from '@/constants/durations'
import { isDevelopmentEnvironment } from '@/utils/environment-utils'

export function setPkceVerifierCookie(codeVerifier: string, options: Partial<OptionsType> = {}): void {
  setCookie(PKCE_VERIFIER_COOKIE, codeVerifier, {
    ...options,
    path: '/',
    secure: !isDevelopmentEnvironment(),
    sameSite: 'lax' as const,
    httpOnly: true,
    maxAge: Durations.FIVE_MINUTES_IN_SECONDS,
  })
}

export function consumePkceVerifierCookie(options: Partial<OptionsType> = {}): string | undefined {
  const value = getCookie(PKCE_VERIFIER_COOKIE, options)
  if (typeof value !== 'string' || !value) return undefined

  deleteCookie(PKCE_VERIFIER_COOKIE, { ...options, path: '/' })

  return value
}
